<template>
  <div class="iconSetting">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'IconSetting',
};
</script>

<style lang="scss">
.iconSetting {
  height: 100%;
}
</style>
